import React from 'react'
import icons from './../../utils/import.icons'

class VideoComponent extends React.Component {

    componentDidMount(){
        console.log(this.props.currentVideo)
    }

    render(){
        return (
            <div className="full-gallery">
                <button className = "close-img" onClick = {() => this.props.handleClose()}>
                        <img src={icons["Close"]} alt=''></img>
                </button>
                <iframe title='' className = "iframe-videos"  src={this.props.currentVideo+"?rel=0?version=3&autoplay=1&controls=0&loop=1&showinfo=0"} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; loop"></iframe>
            </div>
        )
    }
}

export default VideoComponent